// Lob footer component text constants for i18n translation
const currentYear = new Date().getFullYear();

export const LOB_FOOTER_TEXTS = {
  backToTop: 'Back To Top',
  backToTopAriaLabel: 'Back to top of page',
  // Caremark first row links
  aboutCVSCaremark: 'About CVS Caremark',
  contact: 'Contact',
  // Caremark second row links
  termsAndConditions: 'Terms and Conditions',
  privacyPolicy: 'Privacy Policy',
  accessibility: 'Accessibility',
  memberRights: 'Member Rights & Responsbilites',
  vulnerabilityDisclosure: 'Vulnerability Disclosure Program',
  // Copyright per LOB
  caremarkCopyright: `Copyright © ${currentYear} CVS Caremark. All rights reserved`,
  specialtyCopyright: `©${currentYear} CVS Specialty, Inc. All rights reserved.`
};

// Translation configuration for lob footer component
export const LOB_FOOTER_TRANSLATION_CONFIG = [
  { key: 'backToTop', message: LOB_FOOTER_TEXTS.backToTop },
  { key: 'backToTopAriaLabel', message: LOB_FOOTER_TEXTS.backToTopAriaLabel },
  { key: 'aboutCVSCaremark', message: LOB_FOOTER_TEXTS.aboutCVSCaremark },
  { key: 'contact', message: LOB_FOOTER_TEXTS.contact },
  { key: 'termsAndConditions', message: LOB_FOOTER_TEXTS.termsAndConditions },
  { key: 'privacyPolicy', message: LOB_FOOTER_TEXTS.privacyPolicy },
  { key: 'accessibility', message: LOB_FOOTER_TEXTS.accessibility },
  { key: 'memberRights', message: LOB_FOOTER_TEXTS.memberRights },
  { key: 'vulnerabilityDisclosure', message: LOB_FOOTER_TEXTS.vulnerabilityDisclosure },
  { key: 'caremarkCopyright', message: LOB_FOOTER_TEXTS.caremarkCopyright },
  { key: 'specialtyCopyright', message: LOB_FOOTER_TEXTS.specialtyCopyright }
];

// Helper function to process translated items for lob footer component
export const processLobFooterTranslations = (translatedItems: Record<string, string>) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    return {
      backToTop: LOB_FOOTER_TEXTS.backToTop,
      backToTopAriaLabel: LOB_FOOTER_TEXTS.backToTopAriaLabel,
      aboutCVSCaremark: LOB_FOOTER_TEXTS.aboutCVSCaremark,
      contact: LOB_FOOTER_TEXTS.contact,
      termsAndConditions: LOB_FOOTER_TEXTS.termsAndConditions,
      privacyPolicy: LOB_FOOTER_TEXTS.privacyPolicy,
      accessibility: LOB_FOOTER_TEXTS.accessibility,
      memberRights: LOB_FOOTER_TEXTS.memberRights,
      vulnerabilityDisclosure: LOB_FOOTER_TEXTS.vulnerabilityDisclosure,
      caremarkCopyright: LOB_FOOTER_TEXTS.caremarkCopyright,
      specialtyCopyright: LOB_FOOTER_TEXTS.specialtyCopyright
    };
  }

  return {
    backToTop: translatedItems[LOB_FOOTER_TEXTS.backToTop] || LOB_FOOTER_TEXTS.backToTop,
    backToTopAriaLabel: translatedItems[LOB_FOOTER_TEXTS.backToTopAriaLabel] || LOB_FOOTER_TEXTS.backToTopAriaLabel,
    aboutCVSCaremark: translatedItems[LOB_FOOTER_TEXTS.aboutCVSCaremark] || LOB_FOOTER_TEXTS.aboutCVSCaremark,
    contact: translatedItems[LOB_FOOTER_TEXTS.contact] || LOB_FOOTER_TEXTS.contact,
    termsAndConditions: translatedItems[LOB_FOOTER_TEXTS.termsAndConditions] || LOB_FOOTER_TEXTS.termsAndConditions,
    privacyPolicy: translatedItems[LOB_FOOTER_TEXTS.privacyPolicy] || LOB_FOOTER_TEXTS.privacyPolicy,
    accessibility: translatedItems[LOB_FOOTER_TEXTS.accessibility] || LOB_FOOTER_TEXTS.accessibility,
    memberRights: translatedItems[LOB_FOOTER_TEXTS.memberRights] || LOB_FOOTER_TEXTS.memberRights,
    vulnerabilityDisclosure: translatedItems[LOB_FOOTER_TEXTS.vulnerabilityDisclosure] || LOB_FOOTER_TEXTS.vulnerabilityDisclosure,
    caremarkCopyright: translatedItems[LOB_FOOTER_TEXTS.caremarkCopyright] || LOB_FOOTER_TEXTS.caremarkCopyright,
    specialtyCopyright: translatedItems[LOB_FOOTER_TEXTS.specialtyCopyright] || LOB_FOOTER_TEXTS.specialtyCopyright
  };
};
